export default [
    {
        path: "/voucher/canteen/daily-cash",
        component: () => import("@/App/Canteen/Voucher/DailyCash/Components/List.vue"),
        name: "voucher.canteen.daily.cash",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/canteen/daily-cash/entry",
        component: () => import("@/App/Canteen/Voucher/DailyCash/Components/Create.vue"),
        name: "voucher.canteen.daily.cash.create",
        meta: {
            requiresAuth: true,
        },
    },
];
